export default __webpack_public_path__ + "static/media/CNo.65-4.60546cf3.jpg";